import { required, minLength } from 'vuelidate/lib/validators';
import FundPerson from '@/app/modules/fund/components/fund-person/fund-person.vue';
import FundAddPersonModal from '@/app/modules/fund/components/fund-add-person-modal/fund-add-person-modal.vue';

export default {
  name: 'fund-trustee-individual',
  components: {
    FundPerson,
    FundAddPersonModal,
  },
  data: () => ({
    showFundAddTrusteeModal: false,
  }),
  computed: {
    availableMembers() {
      if (this.trustees.length > 0) {
        return this.members.filter(member => !this.trustees.includes(member));
      }
      return this.members;
    },
    trustees() {
      return this.$store.getters['fund/getFund'].trustee.trustees;
    },
    members() {
      return this.$store.getters['fund/getFund'].members;
    },
  },
  methods: {
    backStep() {
      this.$emit('backStep');
    },
    nextStep() {
      this.$emit('nextStep');
    },
    handleDeleteTrustee(pos) {
      const newTrustees = this.trustees.filter((trustee, idx) => idx !== pos);
      this.$store.dispatch('fund/updateFundTrustee', { trustees: newTrustees });
    },
    handleAddTrustee(person) {
      this.$store.dispatch('fund/updateFundTrustee', {
        trustees: [
          ...this.trustees,
          person,
        ],
      });
    },
  },
  validations: {
    trustees: {
      required,
      minLength: minLength(1),
      $each: {
        title: {
          required,
        },
        firstName: {
          required,
          minLength: minLength(2),
        },
        lastName: {
          required,
          minLength: minLength(2),
        },
        dateOfBirth: {
          required,
        },
        sex: {
          required,
        },
      },
    },
  },
};
